var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.361,
    height: 35,
    viewBox: "0 0 38.361 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M166.144,309.822c-.257.246-.509.482-.756.723q-2.6,2.535-5.2,5.071c-.618.6-1.078.515-1.423-.276q-6.834-15.666-13.661-31.335c-.277-.636-.494-1.3-.749-1.944a.714.714,0,0,1,.11-.844.742.742,0,0,1,.844-.139q4.314,1.473,8.63,2.943l27.83,9.47c.11.037.221.07.328.114a.691.691,0,0,1,.277,1.21c-.592.618-1.2,1.216-1.809,1.821-2.03,2.031-4.064,4.057-6.083,6.1a1.383,1.383,0,0,0-.358.7c-.516,3.13-1.008,6.264-1.512,9.4-.121.751-.667.985-1.29.556q-2.364-1.627-4.722-3.263C166.456,310.029,166.311,309.934,166.144,309.822Zm-6.873,3.3c.07-.207.1-.286.123-.367q1.473-6.078,2.951-12.156a.638.638,0,0,0-.226-.678q-7.434-7.455-14.858-14.918c-.082-.083-.176-.154-.264-.231l-.088.063Zm19.7-19.037.012-.078-29.7-10.094a.234.234,0,0,0,.1.18q8.183,6.009,16.373,12.008a.866.866,0,0,0,.592.113c2.658-.435,5.314-.887,7.969-1.337Q176.644,294.479,178.967,294.081Zm-7.429,16.036.1-.016c.366-2.3.737-4.6,1.083-6.9a.6.6,0,0,0-.255-.427q-9.962-7.333-19.937-14.65c-.09-.066-.188-.122-.283-.183l-.064.086a3.621,3.621,0,0,1,.3.247q8.3,8.339,16.608,16.674a4,4,0,0,1,.937,1.432C170.513,307.634,171.034,308.873,171.538,310.117Zm-7.991-8.618-2.773,11.472.09.038,7.218-7.031Zm4.007-4.07,5.805,4.264,6.316-6.316Zm2.727,13.552.07-.044-1.5-3.737-1.575,1.7Z",
    transform: "translate(-144.267 -281.009)",
    fill: "#5dadae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1c0f6a79daeeb5207d93f29990650eeb.svg";
export { ForwardRef as ReactComponent };